import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PermissionService } from '../../../core/services/permission.service';

/**
 * LandingComponent đóng vai trò là "Dispatcher" thông minh.
 * Khi User truy cập vào dấu "/" (Home), component này sẽ dựa trên
 * kết quả phân quyền để tìm ra trang đầu tiên User có thể xem
 * và thực hiện chuyển hướng ngay lập tức.
 */
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [TranslateModule],
  template: `
    <div
      class="d-flex flex-column align-items-center justify-content-center vh-100 w-100 bg-white"
    >
      <div class="spinner-border text-primary mb-3" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="text-secondary fw-medium small">
        {{ 'COMMON.LOADING' | translate }}
      </p>
    </div>
  `,
  styles: [],
})
export class LandingComponent implements OnInit {
  private readonly permissionService = inject(PermissionService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    // 1. Tính toán Route đầu tiên User có quyền
    const firstRoute = this.permissionService.getFirstAccessibleRoute();

    console.log(
      '[LandingComponent] Redirecting to authorized route:',
      firstRoute,
    );

    // 2. Chuyển hướng
    this.router.navigateByUrl(firstRoute, { replaceUrl: true });
  }
}
